// Letter and punctuation slots verified against Russian TD and Georgian typewriter fonts.
export const keyboardLayouts = {
  "latin-russian": {
    "ა": "f",
    "ბ": ",",
    "გ": "u",
    "დ": "l",
    "ე": "t",
    "ვ": "d",
    "ზ": "p",
    "თ": "s",
    "ი": "b",
    "კ": "r",
    "ლ": "k",
    "მ": "v",
    "ნ": "y",
    "ო": "j",
    "პ": "g",
    "ჟ": ";",
    "რ": "h",
    "ს": "c",
    "ტ": "n",
    "უ": "e",
    "ფ": "a",
    "ქ": "m",
    "ღ": "q",
    "ყ": "'",
    "შ": "i",
    "ჩ": "x",
    "ც": "w",
    "ძ": ".",
    "წ": "o",
    "ჭ": "z",
    "ხ": "[",
    "ჯ": "/",
    "ჰ": "]",
    ",": "=",
    ".": "\\",
    ":": "|",
    ";": "+",
    "?": "~",
    "/": "$"
  },
  "latin-typewriter": {
    "0": "_",
    "1": "!",
    "2": "@",
    "3": "#",
    "4": "$",
    "5": "%",
    "6": "^",
    "7": "*",
    "8": "(",
    "9": ")",
    "ა": "g",
    "ბ": ".",
    "გ": "u",
    "დ": ";",
    "ე": "t",
    "ვ": "d",
    "ზ": "p",
    "თ": "f",
    "ი": "n",
    "კ": "r",
    "ლ": "l",
    "მ": "b",
    "ნ": "y",
    "ო": "k",
    "პ": "h",
    "ჟ": "'",
    "რ": "j",
    "ს": "v",
    "ტ": "m",
    "უ": "e",
    "ფ": "a",
    "ქ": ",",
    "ღ": "q",
    "ყ": "c",
    "შ": "i",
    "ჩ": "x",
    "ც": "]",
    "ძ": "s",
    "წ": "o",
    "ჭ": "z",
    "ხ": "[",
    "ჯ": "w",
    "ჰ": "/",
    ",": "7",
    ".": "8",
    ":": "5",
    ";": "9",
    "!": "=",
    "?": "0",
    "(": "~",
    ")": "`",
    "%": "+",
    "-": "2",
    "/": "-"
  }
};
